/**
 * src/components/footer/FooterBottom.js
 *
 * Barra inferior del footer con copyright.
 * Props: { copyright }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('FooterBottom', ({ copyright }) => {
    return h('div', { className: 'footer-bottom' },
        h('div', { className: 'footer-bottom__inner' },
            h('p', { className: 'footer-bottom__copy' }, copyright),
            h('p', { className: 'footer-bottom__made' },
                'Hecho con ❤️ para Fusagasugá'
            )
        )
    )
})
